const TopicList = () => import('Views/topic/topic-list');
const TopicDetail = () => import('Views/topic/topic-detail-new-ui');

export default[
  { path: '/topic-list', component: TopicList },
  { path: '/topic-detail/:id', component: TopicDetail },
];



// WEBPACK FOOTER //
// ./src/router/topic.js